import { __makeTemplateObject } from "tslib";
import { css } from '../../../foundation';
import { RcBackdropClasses } from '../utils';
export var BackdropStyle = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &.", " {\n      background-color: rgba(0, 0, 0, 0.7);\n    }\n  "], ["\n    &.", " {\n      background-color: rgba(0, 0, 0, 0.7);\n    }\n  "])), RcBackdropClasses.root);
};
var templateObject_1;
